const ACTIVE_DRAFT_KEY = "motionAirActiveWorkDraftId";

export function getActiveWorkDraftId() {
  try {
    return localStorage.getItem(ACTIVE_DRAFT_KEY) || "";
  } catch {
    return "";
  }
}

export function setActiveWorkDraftId(id) {
  try {
    if (id) localStorage.setItem(ACTIVE_DRAFT_KEY, id);
    else localStorage.removeItem(ACTIVE_DRAFT_KEY);
  } catch {
    // Ignore quota / private mode.
  }
}

export function draftLabel(draft) {
  const title = (draft?.title || "").trim();
  if (title) return title;
  const slug = (draft?.slug || draft?.loadedSlug || "").trim();
  if (slug) return slug;
  return "Untitled draft";
}

export function formatDraftSavedAt(timestamp) {
  if (!timestamp) return "";
  const seconds = Math.max(0, Math.round((Date.now() - timestamp) / 1000));
  if (seconds < 20) return "Saved just now";
  if (seconds < 60) return "Saved seconds ago";
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `Saved ${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `Saved ${hours}h ago`;
  return `Saved ${new Date(timestamp).toLocaleDateString()}`;
}

export function draftSecondaryText(draft) {
  const parts = [];
  if (draft?.muxAssetId || draft?.muxPlaybackId) parts.push("Video ready");
  else parts.push("No video yet");
  if (draft?.updatedBy) parts.push(draft.updatedBy);
  const saved = formatDraftSavedAt(draft?.updatedAt);
  if (saved) parts.push(saved);
  return parts.join(" · ");
}
